import { Route, Routes } from "react-router-dom";
import "./App.css";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import HomePage from "../src/pages/HomePage";
import Cursor from "./components/Cursor";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import AboutPage from "./pages/AboutPage";
import ContactUsPage from "./pages/ContactUsPage";

import ImagingService from "./components/Imaging Services/ImagingService";
import SingleServicePage from "./components/Imaging Services/SingleServicePage";
import PaymentForm from "./components/MakePayment/PaymentForm";
import PatientForms from "./components/MakePayment/PatientForms";
import PatientReviews from "./components/MakePayment/PatientReviews";
import ForClinics from "./components/ForClinics/ForClinics";
import NotFound from "./components/NotFound";
import ScrollToTopButton from "./components/TopButton";
import SmoothScrollWrapper from "./components/SmoothScroll";

function App() {
  useEffect(() => {
    setTimeout(() => {
      Aos.init({
        duration: 1000,
        once: true,
        easing: "ease-in-out",
      });
    }, 0);
  }, []);

  return (
    <SmoothScrollWrapper>
      <div className="App relative m-0">
        <NavBar />
        <Cursor />
        <ScrollToTopButton />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/make-a-payment" element={<PaymentForm />} />
          <Route path="/for-patient" element={<PatientForms />} />
          <Route path="/patient-reviews" element={<PatientReviews />} />
          <Route path="/for-clinicians" element={<ForClinics />} />
          <Route path="/make-a-payment" element={<PaymentForm />} />
          <Route path="/imaging-services" element={<ImagingService />} />
          <Route path="/services/:slug" element={<SingleServicePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </SmoothScrollWrapper>
  );
}

export default App;
